"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelButton = void 0;
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
const Block_1 = require("./Block");
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
class LevelButton extends Block_1.Block {
    constructor(app, txt, color, textColor) {
        super(app);
        this.txt = txt;
        this.color = color;
        this.background = new pixi_js_1.Graphics();
        // TODO: Make sure this gets cleaned up
        this.text = new pixi_js_1.Text(this.txt, Block_1.Block.textStyle(this.font));
        this.background.name = 'box';
        this.text.name = 'text';
        this.text.anchor.set(0.5);
        this.text.style.align = 'center';
        this.text.style.wordWrap = true;
        this.text.style.wordWrapWidth = (0, Global_1.px)(LevelButton.w - 6);
        this.addChild(this.background, this.text);
        this.text.style.fill = textColor;
        this.layout();
    }
    updateBackground() {
        return this.makeBox({
            borderColor: 0x222222,
            border: 2,
            backgroundColor: this.color,
            vertical: false,
            width: LevelButton.w,
            height: LevelButton.w / 1.75,
            radius: 4
        }, this.background);
    }
    get width() {
        return this.background.width;
    }
    get height() {
        return this.background.height;
    }
    get font() {
        return this.overSmallSize ? 30 : 28;
    }
    // Just to get Typescript to stop wining :(
    setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY) {
        return super.setTransform(x, y, scaleX, scaleY, rotation, skewX, skewY, pivotX, pivotY);
    }
    layout() {
        this.updateBackground();
        this.text.style.fontSize = (0, Global_1.fontSize)(this.font);
        const scaleFactorWidth = this.background.width / this.text.width;
        const scaleFactorHeight = this.background.height / this.text.height;
        const scaleFactor = Math.min(1, Math.min(scaleFactorWidth, scaleFactorHeight));
        this.text.style.fontSize = (0, Global_1.fontSize)(this.font * scaleFactor);
        this.text.position.set(this.background.width / 2, this.background.height / 2);
    }
}
exports.LevelButton = LevelButton;
LevelButton.w = 100;
